import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MagnifyingGlass } from "react-loader-spinner";
import ScrollToTop from "../ScrollToTop";

const helpTopics = [
  {
    title: "Commande et panier",
    faqs: [
      {
        q: "Comment passer une commande ?",
        a: "Ajoutez vos produits Almoune au panier puis suivez les etapes de paiement pour confirmer votre commande.",
      },
      {
        q: "Puis-je modifier mon panier ?",
        a: "Oui, vous pouvez ajuster les quantites, supprimer un article ou appliquer un code promo avant validation.",
      },
    ],
  },
  {
    title: "Livraison",
    faqs: [
      {
        q: "A partir de quel montant la livraison est-elle offerte ?",
        a: "La livraison standard est offerte a partir de 49 EUR.",
      },
      {
        q: "Comment laisser une consigne de livraison ?",
        a: "Vous pouvez indiquer vos instructions pendant le paiement dans la zone prevue a cet effet.",
      },
    ],
  },
  {
    title: "Produits et assistance",
    faqs: [
      {
        q: "Que faire si je cherche un produit precis ?",
        a: "Contactez Almoune par telephone ou par email pour verifier la disponibilite d'une reference.",
      },
      {
        q: "Comment joindre le service client ?",
        a: "Vous pouvez nous contacter au 09 81 39 14 33 ou via la page Contact.",
      },
    ],
  },
];

const HelpCenter = () => {
  const [loaderStatus, setLoaderStatus] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoaderStatus(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      {loaderStatus ? (
        <div className="loader-container">
          <MagnifyingGlass
            visible={true}
            height="100"
            width="100"
            ariaLabel="magnifying-glass-loading"
            wrapperStyle={{}}
            wrapperclassName="magnifying-glass-wrapper"
            glassColor="#c0efff"
            color="#0aad0a"
          />
        </div>
      ) : (
        <>
          <ScrollToTop />
          <section className="my-lg-14 my-8">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="text-center mb-8">
                    <h1 className="fw-bold">Centre d'aide Almoune</h1>
                    <p className="lead mb-0">
                      Les informations utiles pour commander, recevoir votre livraison et contacter la boutique.
                    </p>
                  </div>
                </div>
              </div>

              <div className="row g-4">
                {helpTopics.map((topic) => (
                  <div className="col-lg-4 col-md-6" key={topic.title}>
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body p-5">
                        <h4 className="mb-4">{topic.title}</h4>
                        {topic.faqs.map((faq) => (
                          <div key={faq.q} className="mb-4">
                            <h6 className="mb-2">{faq.q}</h6>
                            <p className="text-muted mb-0">{faq.a}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="card border-0 shadow-sm mt-6">
                <div className="card-body p-5 text-center">
                  <h4 className="mb-2">Besoin d'un accompagnement direct ?</h4>
                  <p className="text-muted mb-4">
                    Notre equipe est disponible pour repondre a vos questions sur les produits, la commande ou la livraison.
                  </p>
                  <div className="d-flex justify-content-center gap-3 flex-wrap">
                    <Link to="/Contact" className="btn btn-primary">
                      Contacter Almoune
                    </Link>
                    <a href="tel:0981391433" className="btn btn-outline-dark">
                      09 81 39 14 33
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default HelpCenter;
